module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content",
    staticStyle: {
      "padding-left": "0px",
      "padding-right": "0px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
  }, [_c('h2', {
    staticClass: "home-topic"
  }, [_vm._v("Favourite Videos")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.allVideos), function(video) {
    return _c('div', {
      key: video.id,
      staticClass: "col-6 col-sm-6 col-md-3 col-lg-3 col-xl-3"
    }, [_c('div', {
      staticClass: "sg-str",
      on: {
        "click": function($event) {
          return _vm.favoritVideo(video.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-star",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), _c('router-link', {
      attrs: {
        "to": '/videos/single-video/' + video.category_id + '/' + video.id
      }
    }, [_c('div', {
      staticClass: "v-boxx"
    }, [_c('div', {
      staticClass: "v-videoo"
    }, [_c('img', {
      attrs: {
        "src": video.thumbnail_large,
        "alt": "..."
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "v-content"
    }, [_c('p', {
      staticClass: "v-name two-line-overflow"
    }, [_vm._v(_vm._s(video.name))]), _vm._v(" "), _c('p', {
      staticClass: "v-disc two-line-overflow"
    }, [_vm._v(_vm._s(video.description))])])])])], 1)
  }), 0)])]), _vm._v(" "), (_vm.noContentVideos && !_vm.noContentErrorMsgVideos) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
  }, [_vm._v("\n        No results found\n      ")])]) : _vm._e(), _vm._v(" "), (_vm.noContentErrorMsgVideos) ? _c('div', {
    staticClass: "row"
  }, [_c('vue-content-loading', {
    attrs: {
      "width": 300,
      "height": 100
    }
  }, [_c('rect', {
    attrs: {
      "x": "0",
      "y": "13",
      "rx": "4",
      "ry": "4",
      "width": "23%",
      "height": "50"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "0",
      "y": "66",
      "rx": "2",
      "ry": "2",
      "width": "23%",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "0",
      "y": "72",
      "rx": "2",
      "ry": "2",
      "width": "14%",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "0",
      "y": "78",
      "rx": "2",
      "ry": "2",
      "width": "23%",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "0",
      "y": "84",
      "rx": "2",
      "ry": "2",
      "width": "23%",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "25%",
      "y": "13",
      "rx": "4",
      "ry": "4",
      "width": "23%",
      "height": "50"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "25%",
      "y": "66",
      "rx": "2",
      "ry": "2",
      "width": "23%",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "25%",
      "y": "72",
      "rx": "2",
      "ry": "2",
      "width": "14%",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "25%",
      "y": "78",
      "rx": "2",
      "ry": "2",
      "width": "23%",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "25%",
      "y": "84",
      "rx": "2",
      "ry": "2",
      "width": "23%",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "51%",
      "y": "13",
      "rx": "4",
      "ry": "4",
      "width": "23%",
      "height": "50"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "51%",
      "y": "66",
      "rx": "2",
      "ry": "2",
      "width": "23%",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "51%",
      "y": "72",
      "rx": "2",
      "ry": "2",
      "width": "14%",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "51%",
      "y": "78",
      "rx": "2",
      "ry": "2",
      "width": "23%",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "51%",
      "y": "84",
      "rx": "2",
      "ry": "2",
      "width": "23%",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "77%",
      "y": "13",
      "rx": "4",
      "ry": "4",
      "width": "23%",
      "height": "50"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "77%",
      "y": "66",
      "rx": "2",
      "ry": "2",
      "width": "23%",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "77%",
      "y": "72",
      "rx": "2",
      "ry": "2",
      "width": "14%",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "77%",
      "y": "78",
      "rx": "2",
      "ry": "2",
      "width": "23%",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "77%",
      "y": "84",
      "rx": "2",
      "ry": "2",
      "width": "23%",
      "height": "3"
    }
  })])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
  }, [_c('h2', {
    staticClass: "home-topic"
  }, [_vm._v("Favourite Documents")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.allDocuments), function(doc) {
    return _c('div', {
      key: doc.id,
      staticClass: "col-6 col-sm-6 col-md-3 col-lg-3 col-xl-3"
    }, [_c('div', {
      staticClass: "sg-str",
      on: {
        "click": function($event) {
          return _vm.favoritDocument(doc.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-star",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), _c('router-link', {
      attrs: {
        "to": '/documents/single-dcument/' + doc.category_id + '/' + doc.id
      }
    }, [_c('div', {
      staticClass: "v-boxx"
    }, [_c('div', {
      staticClass: "v-videoo"
    }, [_c('img', {
      staticClass: "doc-img",
      attrs: {
        "src": "https://smartapprcp.s3.ap-southeast-1.amazonaws.com/" + doc.thumbnail
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "v-content"
    }, [_c('p', {
      staticClass: "v-name two-line-overflow"
    }, [_vm._v(_vm._s(doc.name))]), _vm._v(" "), _c('p', {
      staticClass: "v-disc two-line-overflow"
    }, [_vm._v(_vm._s(doc.description))])])])])], 1)
  }), 0)])]), _vm._v(" "), (_vm.noContentDocs && !_vm.noContentErrorMsgDocuments) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
  }, [_vm._v("\n        No results found\n      ")])]) : _vm._e(), _vm._v(" "), (_vm.noContentErrorMsgDocuments) ? _c('div', {
    staticClass: "row"
  }, [_c('vue-content-loading', {
    attrs: {
      "width": 300,
      "height": 100
    }
  }, [_c('rect', {
    attrs: {
      "x": "0",
      "y": "13",
      "rx": "4",
      "ry": "4",
      "width": "23%",
      "height": "50"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "0",
      "y": "66",
      "rx": "2",
      "ry": "2",
      "width": "23%",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "0",
      "y": "72",
      "rx": "2",
      "ry": "2",
      "width": "14%",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "0",
      "y": "78",
      "rx": "2",
      "ry": "2",
      "width": "23%",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "0",
      "y": "84",
      "rx": "2",
      "ry": "2",
      "width": "23%",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "25%",
      "y": "13",
      "rx": "4",
      "ry": "4",
      "width": "23%",
      "height": "50"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "25%",
      "y": "66",
      "rx": "2",
      "ry": "2",
      "width": "23%",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "25%",
      "y": "72",
      "rx": "2",
      "ry": "2",
      "width": "14%",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "25%",
      "y": "78",
      "rx": "2",
      "ry": "2",
      "width": "23%",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "25%",
      "y": "84",
      "rx": "2",
      "ry": "2",
      "width": "23%",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "51%",
      "y": "13",
      "rx": "4",
      "ry": "4",
      "width": "23%",
      "height": "50"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "51%",
      "y": "66",
      "rx": "2",
      "ry": "2",
      "width": "23%",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "51%",
      "y": "72",
      "rx": "2",
      "ry": "2",
      "width": "14%",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "51%",
      "y": "78",
      "rx": "2",
      "ry": "2",
      "width": "23%",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "51%",
      "y": "84",
      "rx": "2",
      "ry": "2",
      "width": "23%",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "77%",
      "y": "13",
      "rx": "4",
      "ry": "4",
      "width": "23%",
      "height": "50"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "77%",
      "y": "66",
      "rx": "2",
      "ry": "2",
      "width": "23%",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "77%",
      "y": "72",
      "rx": "2",
      "ry": "2",
      "width": "14%",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "77%",
      "y": "78",
      "rx": "2",
      "ry": "2",
      "width": "23%",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "77%",
      "y": "84",
      "rx": "2",
      "ry": "2",
      "width": "23%",
      "height": "3"
    }
  })])], 1) : _vm._e(), _vm._v(" "), _c('back-to-top', {
    attrs: {
      "bottom": "120px",
      "right": "20px",
      "visibleoffset": "20"
    }
  }, [_c('button', {
    staticClass: "scoller-top-btn",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-up"
  })])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-160dbd20"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/user/UserFavourite.vue
// module id = 2068
// module chunks = 1